import { Routes } from '@angular/router';
import { UserGuard } from '../core/guards/user.guard';
import { GuestGuard } from '../core/guards/guest.guard';
import { GlobalParamsGuard } from '../core/guards/global-params.guard';
import { LandingConfigs } from '../core/services/landing.service';
import { UserWithoutMerchantGuard } from '../core/guards/user-without-merchant.guard';

export const landingRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.GENERAL },
  },
  {
    path: 'ref/:referral',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { state: 'referral' }
  },
  {
    path: 'pay/mbway/:id',
    pathMatch: 'full',
    canActivate: [],
    loadComponent: () => import('./mbway-renew/mbway-renew.component').then(m => m.MbwayRenewComponent),
    // data: { config: LandingConfigs.GENERAL },
  },
  {
    path: 'agenda',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./calendar-page/calendar-page.component').then(m => m.CalendarPageComponent),
    // data: { config: LandingConfigs.GENERAL },
  },
  {
    path: 'calendar',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./calendar-page/calendar-page.component').then(m => m.CalendarPageComponent),
    // data: { config: LandingConfigs.GENERAL },
  },
  {
    path: 'pagina-marcacoes',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./booking-page/booking-page.component').then(m => m.BookingPageComponent),
    // data: { config: LandingConfigs.GENERAL },
  },
  {
    path: 'booking-page',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./booking-page/booking-page.component').then(m => m.BookingPageComponent),
    // data: { config: LandingConfigs.GENERAL },
  },
  {
    path: 'barbeiros',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.BARBERS },
  },
  {
    path: 'barbers',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.BARBERS },
  },
  {
    path: 'cabeleireiros',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.SALON },
  },
  {
    path: 'hairdressers',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.SALON },
  },
  {
    path: 'nail-artists',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.NAILS },
  },
  {
    path: 'makeup-artists',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.MAKEUP },
  },
  {
    path: 'personal-trainers',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.FITNESS },
  },
  {
    path: 'reiki',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.REIKI },
  },
  {
    path: 'nutricionistas',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.NUTRITIONIST },
  },
  {
    path: 'nutritionists',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.NUTRITIONIST },
  },
  {
    path: 'fisioterapeutas',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.PHYSIOTHERAPISTS },
  },
  {
    path: 'physiotherapists',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.PHYSIOTHERAPISTS },
  },
  {
    path: 'osteopatas',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.OSTEOPATHS },
  },
  {
    path: 'osteopaths',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.OSTEOPATHS },
  },
  {
    path: 'dentistas',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.DENTIST },
  },
  {
    path: 'dentists',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.DENTIST },
  },
  {
    path: 'psicologos',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.PSYCHOLOGISTS },
  },
  {
    path: 'psychologists',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.PSYCHOLOGISTS },
  },
  {
    path: 'farmacias',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.PHARMACIES },
  },
  {
    path: 'pharmacies',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.PHARMACIES },
  },
  {
    path: 'centros-de-terapias',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.THERAPY },
  },
  {
    path: 'therapy-center',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.THERAPY },
  },
  {
    path: 'ginasios',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.GYMS },
  },
  {
    path: 'gyms',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.GYMS },
  },
  {
    path: 'homeopatia',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.HOMEOPATHY },
  },
  {
    path: 'homeopathy',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.HOMEOPATHY },
  },
  {
    path: 'acupuntura',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.ACUPUNCTURE },
  },
  {
    path: 'acupuncture',
    pathMatch: 'full',
    canActivate: [GuestGuard, GlobalParamsGuard],
    loadComponent: () => import('./landing.component').then(m => m.LandingComponent),
    data: { config: LandingConfigs.ACUPUNCTURE },
  },
  {
    path: 'spa-massagens',
    redirectTo: '',
  },
  {
    path: 'spa-massages',
    redirectTo: '',
  },
  {
    path: 'pet-care',
    redirectTo: '',
  },
  {
    path: 'login',
    canActivate: [GuestGuard],
    loadComponent: () => import('./login-page/login-page.component').then(m => m.LoginPageComponent),
    data: { state: 'login' },
  },
  {
    path: 'signup',
    canActivate: [GuestGuard],
    loadComponent: () => import('./signup/signup.component').then(m => m.SignupComponent),
    data: { state: 'signup' },
  },
  {
    path: 'signup/merchant',
    canActivate: [UserGuard, UserWithoutMerchantGuard],
    loadComponent: () => import('./create-merchant/create-merchant.component').then(m => m.CreateMerchantComponent),
    data: { state: 'setup_merchant' },
  },
  {
    path: 'recoverpass',
    canActivate: [GuestGuard],
    loadComponent: () => import('./recover-pass-page/recover-pass-page.component').then(m => m.RecoverPassPageComponent),
    data: { state: 'signup' },
  },
  {
    path: 'setpassword',
    canActivate: [GuestGuard],
    loadComponent: () => import('./set-password-page/set-password-page.component').then(m => m.SetPasswordPageComponent),
    data: { state: 'signup' },
  },
  {
    path: 'magiclink',
    canActivate: [GuestGuard],
    loadComponent: () => import('./magic-link-page/magic-link-page.component').then(m => m.MagicLinkPageComponent),
    data: { state: 'signup' },
  },
  {
    path: 'logout',
    canActivate: [UserGuard],
    loadComponent: () => import('../shared/logout/logout.component').then(m => m.LogoutComponent),
  },
  {
    path: 'terms',
    loadComponent: () => import('./terms/terms.component').then(m => m.TermsComponent),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./privacy/privacy.component').then(m => m.PrivacyComponent),
  },
  {
    path: 'cookie-policy',
    loadComponent: () => import('./cookies-policy/cookies-policy.component').then(m => m.CookiesPolicyComponent),
  },
  {
    path: 'faqs',
    loadComponent: () => import('./faqs/faqs.component').then(m => m.FaqsComponent),
  },
  {
    path: 'notfound',
    loadComponent: () => import('./not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent),
  },
  {
    path: 'campaign/unsubscribe/:clientId/:clientCode',
    loadComponent: () => import('./unsubscribe-page/unsubscribe-page.component').then(m => m.UnsubscribePageComponent),
  },
];